module.exports = __webpack_public_path__ + "img/podoarttour_main_04.fc7d9de4.jpg";